import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import moment from "moment";
import OrderDataWrapper from "../../orderDataWrapper";
import ExportInitiatedDialog from "ExportIntiaiedDialog";
import useExportInitiated from "CustomHook/ExortInitiatedHook";
import AppConstants from "../../constants";

interface HistoryBaseProps {
  useSelectorData: () => any;
  useCommonSelector: () => any;
  useStyles: any;
  locationIcon: string;
  historyOrdersDataTransform: any;
  createFilterPayload: any;
  fetchOrderListByFilterHistory: any;
  exportToExcelActionCreator: any;
  fetchOrdersFilterChipsDisplayCount: any;
  resetExportInitiated: any;
  getOrderStatusField: any;
  getConsignmentStatusField: any;
  customClassName?: string;
}

const HistoryBase = (props: HistoryBaseProps) => {
  const {
    useSelectorData,
    useCommonSelector,
    useStyles,
    locationIcon,
    historyOrdersDataTransform,
    createFilterPayload,
    fetchOrderListByFilterHistory,
    exportToExcelActionCreator,
    fetchOrdersFilterChipsDisplayCount,
    resetExportInitiated,
    getOrderStatusField,
    getConsignmentStatusField,
    customClassName,
  } = props;

  const dispatch = useSelectorData().dispatch;
  const classes = useStyles();
  const {
    ordersHistoryFiltersDropdowns,
    ordersHistory,
    tableLoading,
    loading,
    exportInitiated,
    reportId,
  } = useSelectorData();
  const { hubCode } = useCommonSelector();

  const [ordersTableWrapperData, setOrdersTableWrapperData] = useState({
    ...AppConstants.CUSTOMER_COMM_HISTORY_CONSTANTS.CONSIGNMENTS_DATA.TABLE_WRAPPER_DATA,
    HeaderData: AppConstants.CUSTOMER_COMM_HISTORY_CONSTANTS.CONSIGNMENTS_DATA.TABLE_WRAPPER_DATA.HeaderData.map(
      (header: any) => {
        const newHeader = { ...header };
        if (newHeader.field === "consignmentId") {
          newHeader.renderCell = (params: any) => (
            <span className="idLink">{params.value}</span>
          );
        }
        if (newHeader.field === "status") {
          newHeader.renderCell = (params: any) =>
            params.value ? (
              <Grid className={classes.statusHeaderContainer} container alignItems="center">
                <span className={["orderTag", getOrderStatusField("color", params.value)].join(" ")}>{params.value ? params.value : ""}</span>
              </Grid>
            ) : null;
        }
        if (newHeader.field === "deliveryStatus") {
          newHeader.renderCell = (params: any) =>
            params.value ? (
              <Grid className={classes.statusHeaderContainer} container alignItems="center">
                <span className={["tag", getConsignmentStatusField("color", params.value)].join(" ")}>{params.value ? params.value : ""}</span>
              </Grid>
            ) : null;
        }
        if (newHeader.field === "actions") {
          newHeader.renderCell = (params: any) => (
            <span className="actionsLink">{params.value}</span>
          );
        }
        if (newHeader.field === "deliveryArea") {
          newHeader.renderCell = (params: any) => (
            <Grid container>
              <Grid item>{params.value}</Grid>
              <Grid item className={classes.infoSection}>
                <img src={locationIcon} alt="info-icon" className={classes.infoIconStyle} />
              </Grid>
            </Grid>
          );
        }
        return newHeader;
      }
    ),
    defaultFiltersObj: {
      ...AppConstants.CUSTOMER_COMM_HISTORY_CONSTANTS.CONSIGNMENTS_DATA.TABLE_WRAPPER_DATA.defaultFiltersObj,
      dateRange: {
        ...AppConstants.CUSTOMER_COMM_HISTORY_CONSTANTS.CONSIGNMENTS_DATA.TABLE_WRAPPER_DATA.defaultFiltersObj.dateRange,
        value: {
          startDate: moment().format(AppConstants.DATE_FORMAT),
          endDate: moment().format(AppConstants.DATE_FORMAT),
        },
      },
    },
  });

  const { openExportInitiatedInfo, handleExportInitiatedDialogClose } = useExportInitiated(resetExportInitiated, exportInitiated);

  const loadTableData = (payload: any) => {
    dispatch(fetchOrderListByFilterHistory({ filters: payload }));
  };
  const exportToExcelAction = (payload: any) => {
    dispatch(exportToExcelActionCreator({ payload }));
  };
  const fetchOrderFilterChips = (payload: any) => {
    dispatch(fetchOrdersFilterChipsDisplayCount({ payload }));
  };

  useEffect(() => {
    if (hubCode || (ordersTableWrapperData && ordersTableWrapperData.HeaderData)) {
      if (ordersTableWrapperData && ordersTableWrapperData.HeaderData) {
        const headerData = ordersTableWrapperData.HeaderData.map((header: any) => {
          if (header.filterObj) {
            if (header.filterObj.fieldName === "hub") {
              header.filterObj.items = ordersHistoryFiltersDropdowns.hubCodeList || [];
            }
            if (header.filterObj.fieldName === "hubName") {
              header.filterObj.items = ordersHistoryFiltersDropdowns.hubNameList || [];
            }
            if (header.filterObj.fieldName === "deliveryStatus") {
              header.filterObj.items = ordersHistoryFiltersDropdowns.statusList || [];
            }
            if (header.filterObj.fieldName === "deliveryArea") {
              header.filterObj.items = ordersHistoryFiltersDropdowns.customerAreaList || [];
            }
            if (header.filterObj.fieldName === "deliveryZone") {
              header.filterObj.items = ordersHistoryFiltersDropdowns.deliveryZonesList || [];
            }
            if (header.filterObj.fieldName === "orderType") {
              header.filterObj.items = ordersHistoryFiltersDropdowns.orderTypeList || [];
            }
            if (header.filterObj.fieldName === "reason") {
              header.filterObj.items = ordersHistoryFiltersDropdowns.reasonList || [];
            }
          }
          return header;
        });
        setOrdersTableWrapperData({ ...ordersTableWrapperData, HeaderData: headerData });
      }
    }
  }, [ordersHistoryFiltersDropdowns, hubCode]);

  return (
    <>
      <Grid item xs={12}>
        <OrderDataWrapper
          ordersTableWrapperData={ordersTableWrapperData}
          trasformData={historyOrdersDataTransform}
          ordersData={ordersHistory}
          loadTableData={loadTableData}
          fetchOrderFilterChips={fetchOrderFilterChips}
          loading={loading}
          tableLoading={tableLoading}
          createFilterPayload={createFilterPayload}
          exportToExcelAction={exportToExcelAction}
          customClass={customClassName || classes.historyContent}
        />
        {openExportInitiatedInfo && (
          <ExportInitiatedDialog
            openExportInitiatedInfo={openExportInitiatedInfo}
            handleDialogClose={handleExportInitiatedDialogClose}
            reportId={reportId}
          />
        )}
      </Grid>
    </>
  );
};

export default HistoryBase;
